"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeoTaxEnvironment = void 0;
// Allowed values of the NEO_TAX_ENV environment variable.
var NeoTaxEnvironment;
(function (NeoTaxEnvironment) {
    NeoTaxEnvironment["TEST"] = "test";
    NeoTaxEnvironment["LOCAL"] = "local";
    NeoTaxEnvironment["DEPLOY_PREVIEW"] = "deploy-preview";
    NeoTaxEnvironment["PRODUCTION_PREVIEW"] = "production-preview";
    NeoTaxEnvironment["DEVELOPMENT"] = "development";
    NeoTaxEnvironment["STAGING"] = "staging";
    NeoTaxEnvironment["PRODUCTION"] = "production";
    NeoTaxEnvironment["TERRAFORM_LOCAL"] = "terraform-local";
    NeoTaxEnvironment["THOMSON_REUTERS"] = "thomson-reuters";
    NeoTaxEnvironment["NARVAR"] = "narvar";
    NeoTaxEnvironment["ZELIS"] = "zelis";
    NeoTaxEnvironment["NBH"] = "nbh";
    NeoTaxEnvironment["ADOBE"] = "adobe";
    NeoTaxEnvironment["LENDINGCLUB"] = "lendingclub";
    NeoTaxEnvironment["SANDBOX"] = "sandbox";
    NeoTaxEnvironment["CAPITALONE"] = "capitalone";
    NeoTaxEnvironment["BULLHORN"] = "bullhorn";
    NeoTaxEnvironment["DEMO"] = "demo";
    NeoTaxEnvironment["QUALCOMM"] = "qualcomm";
    NeoTaxEnvironment["EXPEDIA"] = "expedia";
    NeoTaxEnvironment["SHELL"] = "shell";
})(NeoTaxEnvironment || (exports.NeoTaxEnvironment = NeoTaxEnvironment = {}));
